import axios from 'axios';
import Config from 'Config';
import * as actionTypes from './actions';
import AdminAuth from '../services/AdminAuth';
import {PRODUCT_ITEM_NAME_MAPPING, PRODUCT_KEY_NAME_MAPPING} from "../shared/constant";
import AdvisorAuth from "../services/AdvisorAuth";

function login(dispatch, getState) {

    console.log("login - start");

    let state = getState();
    let registrationData = state.registrationState.registration;

    let advisorId = null;

    dispatch({
        type: actionTypes.CLEAR_ERROR_STATE
    });

    dispatch({
        type: actionTypes.SET_LOADING
    });

    console.log("login - call registration");

    let noOfAdvisors = registrationData.formFields.numberAdvisors.value;
    let noOfClients = registrationData.formFields.numberClients.value;

    if (noOfAdvisors === "SELECT") noOfAdvisors = "";
    if (noOfClients === "SELECT") noOfClients = "";

    axios({
        method: 'post',
        url: Config.serverUrl + "/annuity-calculator/registration",
        data: {
            "email": registrationData.formFields.email.value.toLowerCase(),
            "firstName": registrationData.formFields.firstName.value,
            "lastName": registrationData.formFields.lastName.value,
            "phone": registrationData.formFields.phoneNumber.value,
            "firmName": "GAIC",
            "noOfAdvisors": noOfAdvisors,
            "noOfClients": noOfClients
        },
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response) => {

        console.log("login - registration response");

        let accessToken = response.data.payload.accessToken;
        let data = 'j_username=' + accessToken + '&j_password=' + "wealth123!";

        let promise = axios.get(Config.serverUrl + '/user/current');
        promise.then(() => {

            console.log("login - user/current response");

            axios({
                method: 'post',
                url: Config.serverUrl + '/j_spring_security_check',
                data: data,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            })
                .then((response) => {

                    console.log("login - /j_spring_security_check");

                    let payload = response.data.user;

                    let data = {
                        advisorId: payload.advisor.advisorId,
                        personId: payload.advisor.personId
                    };

                    advisorId = payload.advisor.advisorId;

                    dispatch({
                        type: actionTypes.UPDATE_ADVISOR_DATA,
                        data: data
                    });


                })
                .then(() => {

                    axios.all([
                        axios.get(Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/Firm/getDefaultAllocationModels"),
                        axios.get(Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/assetClassInfo")
                    ])
                        .then((response) => {
                            let allocationList = response[0].data.payload;
                            let assetList = response[1].data.payload;

                            dispatch({
                                type: actionTypes.UPDATE_ALLOCATION_LIST,
                                data: allocationList
                            });

                            dispatch({
                                type: actionTypes.UPDATE_DEFAULT_ASSETS,
                                data: assetList
                            });

                            dispatch({
                                type: actionTypes.CLEAR_LOADING
                            });
                        })
                        .catch(() => {

                            dispatch({
                                type: actionTypes.UNLOCK_REGISTRATION
                            });

                            dispatch({
                                type: actionTypes.SET_ERROR_STATE,
                                errorMessage: "There was a problem while loading inStream Data"
                            });
                        })

                })
                .catch((error) => {

                    dispatch({
                        type: actionTypes.UNLOCK_REGISTRATION
                    });

                    dispatch({
                        type: actionTypes.SET_ERROR_STATE,
                        errorMessage: "There was a problem while registering your email address: "
                    });
                });
        });
    });
}

export function registerUser() {

    return (dispatch, getState) => {
        login(dispatch, getState);
    };

}

export function loginAsCompany(emailAddress, firstName, lastName, firmName, thirdPartyVendor) {
    return (dispatch, getState) => {

        console.log("login - start");

        let state = getState();

        let advisorId = null;

        dispatch({
            type: actionTypes.CLEAR_ERROR_STATE
        });

        dispatch({
            type: actionTypes.SET_LOADING
        });

        console.log("login - call registration");

        axios({
            method: 'post',
            url: Config.serverUrl + "/annuity-calculator/registration",
            data: {
                "email": emailAddress,
                "firstName": firstName,
                "lastName": lastName,
                "phone": "123456789",
                "firmName": firmName,
                "noOfAdvisors": 1,
                "noOfClients": 1,
                "thirdPartyVendor": thirdPartyVendor
            },
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => {

            console.log("login - registration response");

            AdvisorAuth.setJWTToken(response.data.payload);
            getAdvisorInfo(dispatch, getState, response.data.payload.accessToken);
        });
    };
}

function getAdvisorInfo(dispatch, getState, accessToken, fromToken) {
    let advisorId = null;

    let promise = axios({
        method: 'get',
        url: Config.serverUrl + '/annuity-calculator/advisor-info',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        }
    });
    promise.then((response) => {

        console.log("getAdvisorInfo response");

            let payload = response.data;

            let data = {
                advisorId: payload.advisorId,
                // personId: payload.advisor.personId
            };

            advisorId = payload.advisorId;
            if (fromToken) {
                AdvisorAuth.setInstitute(payload.gaigInstitute);
                dispatch({
                    type: actionTypes.SET_COMPANY_NAME,
                    value: payload.gaigInstitute
                });
            }

            dispatch({
                type: actionTypes.UPDATE_ADVISOR_DATA,
                data: data
            });

            // const isWellsFargo = payload["@thirdPartyVendor"] === "WELLSFARGO";
            // dispatch({
            //     type: actionTypes.SET_BYPASS_INTRODUCTION,
            //     data: isWellsFargo
            // });

    })
    .then(() => {
        axios.all([
            axios({
                method: 'get',
                url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/asset-class-info",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + accessToken
                }
            })
        ])
            .then((response) => {
                let assetList = response[0].data;

                dispatch({
                    type: actionTypes.UPDATE_DEFAULT_ASSETS,
                    data: assetList
                });

                dispatch({
                    type: actionTypes.CLEAR_LOADING
                });

                dispatch({
                    type: actionTypes.SET_AUTHORIZED
                });

            })
            .catch(() => {

                dispatch({
                    type: actionTypes.UNLOCK_REGISTRATION
                });

                dispatch({
                    type: actionTypes.SET_ERROR_STATE,
                    errorMessage: "There was a problem while loading inStream Data"
                });
            })

    })
    .catch(() => {

        dispatch({
            type: actionTypes.UNLOCK_REGISTRATION
        });

        dispatch({
            type: actionTypes.SET_ERROR_STATE,
            errorMessage: "There was a problem while registering your email address"
        });
    });
}

export function loadDefaultAllocationModels(indexProtector, history) {
    return (dispatch, getState) => {
        let product;
        if (indexProtector.indexOf("INDEX ACHIEVER") !== -1) {
            product = indexProtector.replace(/ /g, '_');
        } else {
            product = ("IP" + indexProtector).replace(" ", "");
        }

        let state = getState();
        let advisorId = state.registrationState.registration.advisorInfo.advisorId;

        const token = AdvisorAuth.getJWTToken();

        axios.all([
            axios({
                method: 'get',
                url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/default-allocation-models?product=" + product,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
        ])
            .then((response) => {
                let allocationList = response[0].data;

                dispatch({
                    type: actionTypes.UPDATE_ALLOCATION_LIST,
                    data: allocationList
                });

                history.push("/annuityCalculator");
            })
            .catch(() => {
                dispatch({
                    type: actionTypes.SET_ERROR_STATE,
                    errorMessage: "There was a problem while loading inStream Data"
                });
            });
    };
}

function getTokenAndLoginMethod(dispatch, getState, accessToken) {
    dispatch({
        type: actionTypes.SET_LOADING
    });

    AdvisorAuth.setJWTToken({
        accessToken: accessToken,
        expiryIn: 600
    });

    getAdvisorInfo(dispatch, getState, accessToken, true);
}

export function getTokenAndLogin(oneTimeToken) {
    return (dispatch, getState) => {
        return getTokenAndLoginMethod(dispatch, getState, oneTimeToken);
    };
}

export function calculatePlan(type) {

    return (dispatch, getState) => {

        dispatch({
            type: actionTypes.VALIDATE_PLANINFO,
            value: type
        });


        let state = getState();
        let advisorId = state.registrationState.registration.advisorInfo.advisorId;
        let clientId = null;
        let planInfoState = state.planInfo;
        let indexProtector = state.globalState.indexProtector !== null ? state.globalState.indexProtector : "5MVA";
        const productReducer = state.productReducer;

        // if the plan is invalid, return
        if (!state.planInfo.isValid) {
            return;
        }

        dispatch({
            type: actionTypes.SET_LOADING
        });

        dispatch({
            type: actionTypes.RESET_MARKET_CONDITIONS
        });

        const token = AdvisorAuth.getJWTToken();

        axios({
            method: 'post',
            url: Config.serverUrl + '/annuity-calculator/advisor/' + advisorId + '/client/create',
            data: {
                "id": null,
                "advisorId": advisorId,
                "firstName": state.planInfo.clientInfo.firstName.value,
                "middleName": "",
                "lastName": state.planInfo.clientInfo.lastName.value,
                "gender": "Male",
                "salutation": "Mr",
                "dateOfBirth": state.planInfo.clientInfo.dateOfBirth.value.format('YYYY-MM-DD'),
                "status": "Active",
                "retirementAge": 67,
                "lifeExpectancyAge": 95
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then((response) => {

            clientId = response.data;

            dispatch({
                type: actionTypes.UPDATE_CLIENT_ID,
                data: clientId
            });

        }).then(() => {
            let planCreateData;
            if (indexProtector.indexOf("INDEX ACHIEVER") !== -1) {
                const productRate = productReducer.rilaData.filter(item => item.key === indexProtector)[0];
                let ext;
                if (planInfoState.accountInfo.value > 250000) {
                    ext = "Over250K";
                } else {
                    ext = "";
                }
                const indexModel = [
                    {
                        assetName: productRate["sp500Minus10Percentage" + ext].assetName,
                        indexId: productRate["sp500Minus10Percentage" + ext].indexId,
                        indexName: productRate["sp500Minus10Percentage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.sp500Minus10Percentage
                    },
                    {
                        assetName: productRate["sp500OneYear10Percentage" + ext].assetName,
                        indexId: productRate["sp500OneYear10Percentage" + ext].indexId,
                        indexName: productRate["sp500OneYear10Percentage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.sp500OneYear10Percentage
                    },
                    {
                        assetName: productRate["eafeOneYear10Percenpage" + ext].assetName,
                        indexId: productRate["eafeOneYear10Percenpage" + ext].indexId,
                        indexName: productRate["eafeOneYear10Percenpage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.eafeOneYear10Percenpage
                    },
                    {
                        assetName: productRate["realEstateOneYear10Percentage" + ext].assetName,
                        indexId: productRate["realEstateOneYear10Percentage" + ext].indexId,
                        indexName: productRate["realEstateOneYear10Percentage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.realEstateOneYear10Percentage
                    },
                    {
                        assetName: productRate["spdrOneYear10Percentage" + ext].assetName,
                        indexId: productRate["spdrOneYear10Percentage" + ext].indexId,
                        indexName: productRate["spdrOneYear10Percentage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.spdrOneYear10Percentage
                    }
                ];
                if (indexProtector === "INDEX ACHIEVER ADVISORY") {
                    indexModel.push({
                        assetName: productRate["sp500OneYear50Percentage" + ext].assetName,
                        indexId: productRate["sp500OneYear50Percentage" + ext].indexId,
                        indexName: productRate["sp500OneYear50Percentage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.sp500OneYear50Percentage
                    });
                    indexModel.push({
                        assetName: productRate["sp500SixYear10Percentage" + ext].assetName,
                        indexId: productRate["sp500SixYear10Percentage" + ext].indexId,
                        indexName: productRate["sp500SixYear10Percentage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.sp500SixYear10Percentage
                    });
                    indexModel.push({
                        assetName: productRate["eafeOneYear50Percenpage" + ext].assetName,
                        indexId: productRate["eafeOneYear50Percenpage" + ext].indexId,
                        indexName: productRate["eafeOneYear50Percenpage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.eafeOneYear50Percenpage
                    });
                    indexModel.push({
                        assetName: productRate["realEstateOneYear50Percentage" + ext].assetName,
                            indexId: productRate["realEstateOneYear50Percentage" + ext].indexId,
                        indexName: productRate["realEstateOneYear50Percentage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.realEstateOneYear50Percentage
                    });
                    indexModel.push({
                        assetName: productRate["spdrOneYear50Percentage" + ext].assetName,
                        indexId: productRate["spdrOneYear50Percentage" + ext].indexId,
                        indexName: productRate["spdrOneYear50Percentage" + ext].indexName,
                        value: planInfoState.IndexAchiever.indexAllocation.spdrOneYear50Percentage
                    });
                }
                planCreateData = {
                    accountValue: planInfoState.accountInfo.value,
                    productType: indexProtector.replace(/ /g, '_'),
                    percentAllocatedToIP: planInfoState.IndexAchiever.percentageAllocation.value,
                    indexModel: indexModel,
                    allocationModel: {
                        allocationModelId: planInfoState.allocation.allocationId,
                        allocationModelName: planInfoState.allocation.allocationName,
                        assets: planInfoState.allocation.assets,
                        overallCap: 0.0,
                        overallProtection: 0.0,
                        returnRate: 0.0,
                        risk: 0.0,
                        annualizedReturn: 0.0
                    },
                };
            } else {
                const productRate = productReducer.productsData.filter(item => item.key === "IP" + indexProtector)[0];
                const indexModel = [
                    {
                        assetName: productRate.riskControl.assetName,
                        indexId: productRate.riskControl.indexId,
                        indexName: productRate.riskControl.indexName,
                        value: planInfoState.IP7.indexAllocation.sandrcntl
                    },
                    {
                        assetName: productRate.retireeSpending.assetName,
                        indexId: productRate.retireeSpending.indexId,
                        indexName: productRate.retireeSpending.indexName,
                        value: planInfoState.IP7.indexAllocation.retiree
                    },
                    {
                        assetName: productRate.sp500.assetName,
                        indexId: productRate.sp500.indexId,
                        indexName: productRate.sp500.indexName,
                        value: planInfoState.IP7.indexAllocation.sandp
                    },
                    {
                        assetName: productRate.yir.assetName,
                        indexId: productRate.yir.indexId,
                        indexName: productRate.yir.indexName,
                        value: planInfoState.IP7.indexAllocation.yr
                    },
                    {
                        assetName: productRate.efa.assetName,
                        indexId: productRate.efa.indexId,
                        indexName: productRate.efa.indexName,
                        value: planInfoState.IP7.indexAllocation.indexEAFE
                    },
                    /*{
                        assetName: productRate.barclay.assetName,
                        indexId: productRate.barclay.indexId,
                        indexName: productRate.barclay.indexName,
                        value: planInfoState.IP7.indexAllocation.barclay
                    }*/
                ];
                if (productRate.barclay) {
                    indexModel.push({
                        assetName: productRate.barclay.assetName,
                        indexId: productRate.barclay.indexId,
                        indexName: productRate.barclay.indexName,
                        value: planInfoState.IP7.indexAllocation.barclay
                    });
                }
                planCreateData = {
                    accountValue: planInfoState.accountInfo.value,
                    productType: ("IP" + indexProtector).replace(" ", ""),
                    percentAllocatedToIP: planInfoState.IP7.percentageAllocation.value,
                    indexModel: indexModel,
                    interestRate: planInfoState.IP7.indexAllocation.interestRate,
                    allocationModel: {
                        allocationModelId: planInfoState.allocation.allocationId,
                        allocationModelName: planInfoState.allocation.allocationName,
                        assets: planInfoState.allocation.assets,
                        overallCap: 0.0,
                        overallProtection: 0.0,
                        returnRate: 0.0,
                        risk: 0.0,
                        annualizedReturn: 0.0
                    },
                };
            }

            axios.all([
                axios({
                    method: 'post',
                    url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/client/" + clientId + "/plan/create",
                    data: planCreateData,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                })
            ]).then((response) => {

                let data = response[0].data;
                let planAId = data[0].autoCorrectedObject.planId;
                let planBId = data[1].autoCorrectedObject.planId;

                dispatch({
                    type: actionTypes.SET_STANDARD_PLANID,
                    data: planAId
                });

                dispatch({
                    type: actionTypes.SET_IP7PLAN_PLANID,
                    data: planBId
                });

                axios.all([
                    axios({
                        method: 'get',
                        url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/client/" + clientId + "/plan/" + planAId + "/calculate",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token
                        }
                    })
                ]).then((response) => {
                    const standardPlanData = response[0].data;
                    axios.all([
                        axios({
                            method: 'get',
                            url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/client/" + clientId + "/plan/" + planBId + "/calculate?basePlanId=" + planAId,
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + token
                            }
                        })
                    ]).then((response) => {
                        dispatch({
                            type: actionTypes.UPDATE_STANDARD_PLAN,
                            data: standardPlanData
                        });

                        dispatch({
                            type: actionTypes.UPDATE_IP7_PLAN,
                            data: response[0].data
                        });

                        dispatch({
                            type: actionTypes.SAVE_BACKUP_ALLOCATIONS
                        });

                        dispatch({
                            type: actionTypes.CLEAR_LOADING
                        });

                        dispatch({
                            type: actionTypes.SUBMITTED_PLAN_INFO
                        });
                    }).catch((error) => {
                        console.log(error);
                        dispatch({
                            type: actionTypes.SET_ERROR_STATE,
                            errorMessage: "There was a problem calculating the plan."
                        });
                    });
                }).catch((error) => {
                    console.log(error);
                    dispatch({
                        type: actionTypes.SET_ERROR_STATE,
                        errorMessage: "There was a problem calculating the plan."
                    });
                });
            }).catch((error) => {
                console.log(error);
                dispatch({
                    type: actionTypes.SET_ERROR_STATE,
                    errorMessage: "There was a problem calculating the plan."
                });
            });
        }).catch((error) => {
            console.log(error);
            dispatch({
                type: actionTypes.SET_ERROR_STATE,
                errorMessage: "There was a problem calculating the plan."
            });
        });
    }

}

export function verifyEmailAddress(email, recaptcha) {
    return (dispatch, getState) => {

        console.log("verifyEmailAddress - start");

        dispatch({
            type: actionTypes.SET_LOADING
        });

        axios.post(Config.serverUrl + "/annuity-calculator/user/verifyEmailAndReCaptcha", {
            email: email.toLowerCase(),
            recaptchaResponse: recaptcha
        })
            .then((response) => {

                console.log("verifyEmailAddress - response obtained");

                if (response.data.payload.advisorUserExist && response.data.payload.recaptchaValid) {

                    console.log("verifyEmailAddress - user exists");

                    dispatch({
                        type: actionTypes.REGISTRATION_UPDATE_EMAIL,
                        email: email
                    });

                    login(dispatch, getState);

                } else if (response.data.payload.recaptchaValid) {
                    dispatch({
                        type: actionTypes.REGISTRATION_UPDATE_EMAIL,
                        email: email
                    });

                    dispatch({
                        type: actionTypes.CLEAR_LOADING
                    });

                } else {
                    dispatch({
                        type: actionTypes.SET_ERROR_STATE,
                        errorMessage: "There was a problem verifying your email address."
                    });
                }
            })
            .catch(() => {
                dispatch({
                    type: actionTypes.SET_ERROR_STATE,
                    errorMessage: "There was a problem verifying your email address."
                });
            });
        ;

    };
}

export function updateIP7PlanCalculations() {
    return (dispatch, getState) => {

        let now = new Date();

        let state = getState();
        let advisorId = state.registrationState.registration.advisorInfo.advisorId;
        let clientId = state.planInfo.clientInfo.clientId;
        let planId = state.planOutputState.IP7Plan.planId;
        let basePlanId = state.planOutputState.standardPlan.planId;
        let indexProtector = state.globalState.indexProtector;

        if (state.planOutputState.IP7Plan.allocation.invalid) return;

        let allocationPost = {
            "allocationModelId": state.planOutputState.IP7Plan.allocation.allocationModelId,
            "allocationModelName": state.planOutputState.IP7Plan.allocation.allocationModelName,
            "objectScope": "PLAN",
            "assets": Array.from(state.planOutputState.IP7Plan.allocation.assets),
            "returnRate": 0.0,
            "risk": 0.0,
            "annualizedReturn": 0.0,
            "historicalAnnualizedReturn": null,
            "expenseRatio": 0.0000,
            "customValues": false,
            "customReturnRate": 0.0000,
            "customRisk": 0.0000,
            "customAnnualizedReturn": 0.0000,
            "taxDrag": null,
            "planId": null,
            "createdDate": 1521210596000,
            "lastUpdateDate": 1521210596000,
            "createdBy": "hg hjg",
            "lastUpdatedBy": "hg hjg",
            "defaultForPlan": false,
            "assetClassAllocationViewModel": null,
            "portfolioId": null
        };

        dispatch({
            type: actionTypes.SET_LOADING
        });

        dispatch({
            type: actionTypes.SAVE_BACKUP_ALLOCATIONS
        });

        const token = AdvisorAuth.getJWTToken();

        axios({
            method: 'post',
            url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/client/" + clientId + "/plan/" + planId + "/allocation-model?timestamp=" + now.getTime().toString(),
            data: allocationPost,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then((response) => {
            axios({
                method: 'get',
                url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/client/" + clientId + "/plan/" + planId + "/calculate?basePlanId=" + basePlanId + "&timestamp=" + now.getTime().toString() + "&indexProtectorType=" + "TYPE_" + indexProtector.replace(" ", ""),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then((response) => {
                    dispatch({
                        type: actionTypes.UPDATE_IP7_PLAN,
                        data: response.data
                    });

                    dispatch({
                        type: actionTypes.CLEAR_LOADING
                    });

                    dispatch({
                        type: actionTypes.SET_IP7_NONEDITABLE
                    });
                })
                .catch(() => {
                    dispatch({
                        type: actionTypes.SET_ERROR_STATE,
                        errorMessage: "There was a problem calculating the plan."
                    });
                });
            })
            .catch(() => {
                dispatch({
                    type: actionTypes.SET_ERROR_STATE,
                    errorMessage: "There was a problem updating the allocation model."
                });
            });
    };
}

export function updateMarketRisk() {

    return (dispatch, getState) => {

        let now = new Date();

        let state = getState();
        let advisorId = state.registrationState.registration.advisorInfo.advisorId;
        let clientId = state.planInfo.clientInfo.clientId;
        let planId = state.planOutputState.IP7Plan.planId;
        let basePlanId = state.planOutputState.standardPlan.planId;
        let indexProtector = state.globalState.indexProtector;
        const token = AdvisorAuth.getJWTToken();

        dispatch({
            type: actionTypes.SET_LOADING
        });

        dispatch({
            type: actionTypes.BACKUP_MARKET_CONDITIONS
        });

        axios({
            method: 'post',
            url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/client/" + clientId + "/market-risk",
            data: {
                "equity": state.planOutputState.conditions.equity,
                "interestRate": state.planOutputState.conditions.interest
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(() => {
                axios
                    .all([
                        axios({
                            method: 'get',
                            url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/client/" + clientId + "/plan/" + basePlanId + "/calculate?timestamp=" + now.getTime().toString() + "&indexProtectorType=" + "TYPE_" + indexProtector.replace(" ", ""),
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + token
                            }
                        })
                    ])
                    .then((response) => {
                        const standardPlanData = response[0].data;
                        axios
                            .all([
                                axios({
                                    method: 'get',
                                    url: Config.serverUrl + "/annuity-calculator/advisor/" + advisorId + "/client/" + clientId + "/plan/" + planId + "/calculate?basePlanId=" + basePlanId + "&timestamp=" + now.getTime().toString() + "&indexProtectorType=" + "TYPE_" + indexProtector.replace(" ", ""),
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + token
                                    }
                                })
                            ])
                            .then((response) => {
                                dispatch({
                                    type: actionTypes.UPDATE_STANDARD_PLAN,
                                    data: standardPlanData
                                });

                                dispatch({
                                    type: actionTypes.UPDATE_IP7_PLAN,
                                    data: response[0].data
                                });

                                dispatch({
                                    type: actionTypes.CLEAR_LOADING
                                });

                                window.scrollTo(0, 0);
                            })
                            .catch(() => {
                                dispatch({
                                    type: actionTypes.SET_ERROR_STATE,
                                    errorMessage: "There was a problem calculating the plan."
                                });
                            });
                    })
                    .catch(() => {
                        dispatch({
                            type: actionTypes.SET_ERROR_STATE,
                            errorMessage: "There was a problem calculating the plan."
                        });
                    });
            });

    };

}

export function generateDownloadUrl(pdfOutput) {
    return (dispatch, getState) => {
        dispatch({
            type: actionTypes.SET_LOADING
        });


        let companyName = getState().globalState.companyName;
        if (companyName === "") companyName = "prince";

        let url = Config.princeStyles;


        let htmltext = '<!DOCTYPE html>' +
            '<html>' +
            '<head lang="en">' +
            '    <meta charset="UTF-8">' +
            '    <title>PDF Report</title>' +
            '    <link rel="stylesheet" href="' + url + '/' + companyName + '.css" />' +
            '</head>' +
            '<body>' +
            '   <div class="planOutput">';


        let output = htmltext + pdfOutput + "   </div></body></html>";
        let state = getState();
        let advisorId = state.registrationState.registration.advisorInfo.advisorId;
        let clientId = state.planInfo.clientInfo.clientId;
        const token = AdvisorAuth.getJWTToken();

        axios({
            method: 'post',
            url: Config.serverUrl + "/annuity-calculator/client/" + clientId + "/generate-pdf",
            data: output,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then((response) => {

                let filename = escape(response.data);

                dispatch({
                    type: actionTypes.SET_DOWNLOAD_URL,
                    data: Config.serverUrl + "/annuity-calculator/plan/output/download-pdf?fileName=" + filename.replace(".pdf", "")
                });

                dispatch({
                    type: actionTypes.CLEAR_LOADING
                });

            });
    };
}

export function getProductsConfiguration() {
    return (dispatch, getState) => {
        dispatch({
            type: actionTypes.SET_LOADING
        });

        const token = AdvisorAuth.getJWTToken();
        const institute = AdvisorAuth.getInstitute();
        axios.all([
            axios({
                method: 'get',
                url: Config.serverUrl + "/annuity-calculator/institute-products?institute=" + institute,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }),
            axios({
                method: 'get',
                url: Config.serverUrl + "/annuity-calculator/product-rates-list",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
        ])
            .then((response) => {
                let instituteProducts = response[0].data;
                let productRates = response[1].data;

                const productRatesData = prepareProductRates(productRates, [instituteProducts]);

                dispatch({
                    type: actionTypes.GET_PRODUCTS_CONFIGURATION,
                    data: {
                        productsData: productRatesData[0],
                        rilaData: productRatesData[1]
                    }
                });

                dispatch({
                    type: actionTypes.CLEAR_LOADING
                });
            });
    }
}

export function getAdminProductsConfiguration() {
    return (dispatch, getState) => {
        dispatch({
            type: actionTypes.SET_LOADING
        });

        const token = AdminAuth.getJWTToken();
        axios.all([
            axios({
                method: 'get',
                url: Config.serverUrl + "/annuity-calculator/institute-product-list",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }),
            axios({
                method: 'get',
                url: Config.serverUrl + "/annuity-calculator/product-rates-list",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
        ])
        .then((response) => {
            let instituteProducts = response[0].data;
            let productRates = response[1].data;

            const productRatesData = prepareProductRates(productRates, instituteProducts);

            dispatch({
                type: actionTypes.GET_PRODUCTS_CONFIGURATION,
                data: {
                    productsData: productRatesData[0],
                    rilaData: productRatesData[1]
                }
            });

            dispatch({
                type: actionTypes.CLEAR_LOADING
            });
        });
    }
}

function prepareProductRates(productRates, instituteProducts) {
    const productsData = productRates
        .filter(productRate => productRate.calculatorCategoryType === "FIXED_INDEX_ANNUITIES")[0].productRatesList
        .map(productRate => {
            let product = {
                key: PRODUCT_KEY_NAME_MAPPING[productRate.gaigProductType],
                yir: {},
                efa: {},
                retireeSpending: {},
                riskControl: {},
                sp500: {},
                userGroupGaig: instituteProducts.filter(product => product.name === "GAIG").length > 0 ?
                    instituteProducts.filter(product => product.name === "GAIG")[0].gaigProductTypeList.indexOf(productRate.gaigProductType) !== -1 : false,
                userGroupRJ: instituteProducts.filter(product => product.name === "Raymond James").length > 0 ?
                    instituteProducts.filter(product => product.name === "Raymond James")[0].gaigProductTypeList.indexOf(productRate.gaigProductType) !== -1 : false,
                userGroupWellsFargo: instituteProducts.filter(product => product.name === "Wells Fargo").length > 0 ?
                    instituteProducts.filter(product => product.name === "Wells Fargo")[0].gaigProductTypeList.indexOf(productRate.gaigProductType) !== -1 : false,
                userGroupMmfa: instituteProducts.filter(product => product.name === "Mass Mutual Financial Advisors").length > 0 ?
                    instituteProducts.filter(product => product.name === "Mass Mutual Financial Advisors")[0].gaigProductTypeList.indexOf(productRate.gaigProductType) !== -1 : false
            };
            productRate.productAmountInfo[0].productInfo.forEach(info => {
                const assetName = info.assetName;
                info.productRates.forEach(rate => {
                    if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.yir) {
                        product.yir = {
                            ...rate,
                            value: rate.value * 100.0,
                            assetName: assetName
                        };
                    } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.efa) {
                        product.efa = {
                            ...rate,
                            value: rate.value * 100.0,
                            assetName: assetName
                        };
                    } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.retireeSpending) {
                        product.retireeSpending = {
                            ...rate,
                            value: rate.value * 100.0,
                            assetName: assetName
                        };
                    } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.riskControl) {
                        product.riskControl = {
                            ...rate,
                            value: rate.value * 100.0,
                            assetName: assetName
                        };
                    } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.sp500) {
                        product.sp500 = {
                            ...rate,
                            value: rate.value * 100.0,
                            assetName: assetName
                        };
                    } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.barclay) {
                        product.barclay = {
                            ...rate,
                            value: rate.value * 100,
                            assetName: assetName
                        }
                    }
                });
            });
            return product;
        });

    const rilaData = productRates
        .filter(productRate => productRate.calculatorCategoryType === "RILA")[0].productRatesList
        .map(productRate => {
            let product = {
                key: PRODUCT_KEY_NAME_MAPPING[productRate.gaigProductType],
                sp500Minus10PercentageOver250K: {},
                sp500OneYear50PercentageOver250K: {},
                sp500OneYear10PercentageOver250K: {},
                sp500SixYear10PercentageOver250K: {},
                eafeOneYear50PercenpageOver250K: {},
                eafeOneYear10PercenpageOver250K: {},
                realEstateOneYear50PercentageOver250K: {},
                realEstateOneYear10PercentageOver250K: {},
                spdrOneYear50PercentageOver250K: {},
                spdrOneYear10PercentageOver250K: {},
                sp500Minus10Percentage: {},
                sp500OneYear50Percentage: {},
                sp500OneYear10Percentage: {},
                sp500SixYear10Percentage: {},
                eafeOneYear50Percenpage: {},
                eafeOneYear10Percenpage: {},
                realEstateOneYear50Percentage: {},
                realEstateOneYear10Percentage: {},
                spdrOneYear50Percentage: {},
                spdrOneYear10Percentage: {},
                userGroupGaig: instituteProducts.filter(product => product.name === "GAIG").length > 0 ?
                    instituteProducts.filter(product => product.name === "GAIG")[0].gaigProductTypeList.indexOf(productRate.gaigProductType) !== -1 : false,
                userGroupRJ: instituteProducts.filter(product => product.name === "Raymond James").length > 0 ?
                    instituteProducts.filter(product => product.name === "Raymond James")[0].gaigProductTypeList.indexOf(productRate.gaigProductType) !== -1 : false,
                userGroupWellsFargo: instituteProducts.filter(product => product.name === "Wells Fargo").length > 0 ?
                    instituteProducts.filter(product => product.name === "Wells Fargo")[0].gaigProductTypeList.indexOf(productRate.gaigProductType) !== -1 : false,
                userGroupMmfa: instituteProducts.filter(product => product.name === "Mass Mutual Financial Advisors").length > 0 ?
                    instituteProducts.filter(product => product.name === "Mass Mutual Financial Advisors")[0].gaigProductTypeList.indexOf(productRate.gaigProductType) !== -1 : false
            };
            productRate.productAmountInfo.forEach(item => {
                if (item.portfolioAmount > 250000) {
                    item.productInfo.forEach(info => {
                        const assetName = info.assetName;
                        info.productRates.forEach(rate => {
                            if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.sp500Minus10Percentage) {
                                product.sp500Minus10PercentageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.sp500OneYear50Percentage) {
                                product.sp500OneYear50PercentageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.sp500OneYear10Percentage) {
                                product.sp500OneYear10PercentageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.sp500SixYear10Percentage) {
                                product.sp500SixYear10PercentageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.eafeOneYear50Percenpage) {
                                product.eafeOneYear50PercenpageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.eafeOneYear10Percenpage) {
                                product.eafeOneYear10PercenpageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.realEstateOneYear50Percentage) {
                                product.realEstateOneYear50PercentageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.realEstateOneYear10Percentage) {
                                product.realEstateOneYear10PercentageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.spdrOneYear50Percentage) {
                                product.spdrOneYear50PercentageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.spdrOneYear10Percentage) {
                                product.spdrOneYear10PercentageOver250K = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            }
                        });
                    });
                } else {
                    item.productInfo.forEach(info => {
                        const assetName = info.assetName;
                        info.productRates.forEach(rate => {
                            if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.sp500Minus10Percentage) {
                                product.sp500Minus10Percentage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.sp500OneYear50Percentage) {
                                product.sp500OneYear50Percentage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.sp500OneYear10Percentage) {
                                product.sp500OneYear10Percentage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.sp500SixYear10Percentage) {
                                product.sp500SixYear10Percentage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.eafeOneYear50Percenpage) {
                                product.eafeOneYear50Percenpage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.eafeOneYear10Percenpage) {
                                product.eafeOneYear10Percenpage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.realEstateOneYear50Percentage) {
                                product.realEstateOneYear50Percentage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.realEstateOneYear10Percentage) {
                                product.realEstateOneYear10Percentage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.spdrOneYear50Percentage) {
                                product.spdrOneYear50Percentage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            } else if (rate.indexName === PRODUCT_ITEM_NAME_MAPPING.spdrOneYear10Percentage) {
                                product.spdrOneYear10Percentage = {
                                    ...rate,
                                    value: rate.value * 100.0,
                                    assetName: assetName
                                };
                            }
                        });
                    });
                }
            });
            return product;
        });
    return [productsData, rilaData];
}

export function adminLogin(userName, password) {
    return (dispatch, getState) => {
        dispatch({
            type: actionTypes.CLEAR_ADMIN_LOGIN_ERROR
        });

        axios({
            method: 'post',
            url: Config.serverUrl + "/annuity-calculator/admin-login",
            data: {
                userName: userName,
                password: password
            },
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                AdminAuth.setJWTToken(response.data);
                dispatch({
                    type: actionTypes.CLEAR_LOADING
                });

                dispatch({
                    type: actionTypes.ADMIN_SUCCESSFULY_LOGGED_IN
                })
            }).catch((err) => {
                dispatch({
                    type: actionTypes.SET_ADMIN_LOGIN_ERROR,
                    errorMessage: "Wrong credentials"
                });
            });
    }
}

export function adminLogOut() {
    return (dispatch, getState) => {
        AdminAuth.clearTokenFromLocalStorage();

        dispatch({
            type: actionTypes.ADMIN_SUCCESSFULY_LOGGED_OUT
        });
    }
}

export function updateRates(
    ip4,
    ip5mva,
    ip7,
    ip5,
    ia,
    iaadvisory
) {
    return (dispatch, getState) => {
        const token = AdminAuth.getJWTToken();
        axios.all([
            axios({
                method: 'post',
                url: Config.serverUrl + "/annuity-calculator/product-rates",
                data: ip4,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }),
            axios({
                method: 'post',
                url: Config.serverUrl + "/annuity-calculator/product-rates",
                data: ip5mva,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }),
            axios({
                method: 'post',
                url: Config.serverUrl + "/annuity-calculator/product-rates",
                data: ip7,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }),
            axios({
                method: 'post',
                url: Config.serverUrl + "/annuity-calculator/product-rates",
                data: ip5,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }),
            axios({
                method: 'post',
                url: Config.serverUrl + "/annuity-calculator/product-rates",
                data: ia,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }),
            axios({
                method: 'post',
                url: Config.serverUrl + "/annuity-calculator/product-rates",
                data: iaadvisory,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
        ]).then((response) => {
            dispatch({
                type: actionTypes.ADMIN_PAGE_SET_SAVED,
                value: true
            });

        }).catch((err) => {
            dispatch({
                type: actionTypes.SET_ERROR_STATE,
                errorMessage: "There was a problem when saving product rates to the database."
            });
        });
    }
}

export function updateProducts(
    ip4_userGroupGaig,
    ip4_userGroupRJ,
    ip4_userGroupWellsFargo,
    ip4_userGroupMmfa,
    ip5mva_userGroupGaig,
    ip5mva_userGroupRJ,
    ip5mva_userGroupWellsFargo,
    ip5mva_userGroupMmfa,
    ip7_userGroupGaig,
    ip7_userGroupRJ,
    ip7_userGroupWellsFargo,
    ip7_userGroupMmfa,
    ip5_userGroupGaig,
    ip5_userGroupRJ,
    ip5_userGroupWellsFargo,
    ip5_userGroupMmfa,
    ia_userGroupGaig,
    ia_userGroupRJ,
    ia_userGroupWellsFargo,
    ia_userGroupMmfa,
    iaadvisory_userGroupGaig,
    iaadvisory_userGroupRJ,
    iaadvisory_userGroupWellsFargo,
    iaadvisory_userGroupMmfa
) {
    return (dispatch, getState) => {
        const token = AdminAuth.getJWTToken();

        axios({
            method: 'get',
            url: Config.serverUrl + "/annuity-calculator/institute-product-list",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then((response) => {
            const data = response.data.map(item => {
                let gaigProductTypeList = [];
                if (item.name === "GAIG") {
                    if (ip4_userGroupGaig) gaigProductTypeList.push("IP4");
                    if (ip5mva_userGroupGaig) gaigProductTypeList.push("IP5MVA");
                    if (ip7_userGroupGaig) gaigProductTypeList.push("IP7");
                    if (ip5_userGroupGaig) gaigProductTypeList.push("IP5");
                    if (ia_userGroupGaig) gaigProductTypeList.push("INDEX_ACHIEVER");
                    if (iaadvisory_userGroupGaig) gaigProductTypeList.push("INDEX_ACHIEVER_ADVISORY");
                } else if (item.name === "Raymond James") {
                    if (ip4_userGroupRJ) gaigProductTypeList.push("IP4");
                    if (ip5mva_userGroupRJ) gaigProductTypeList.push("IP5MVA");
                    if (ip7_userGroupRJ) gaigProductTypeList.push("IP7");
                    if (ip5_userGroupRJ) gaigProductTypeList.push("IP5");
                    if (ia_userGroupRJ) gaigProductTypeList.push("INDEX_ACHIEVER");
                    if (iaadvisory_userGroupRJ) gaigProductTypeList.push("INDEX_ACHIEVER_ADVISORY");
                } else if (item.name === "Wells Fargo") {
                    if (ip4_userGroupWellsFargo) gaigProductTypeList.push("IP4");
                    if (ip5mva_userGroupWellsFargo) gaigProductTypeList.push("IP5MVA");
                    if (ip7_userGroupWellsFargo) gaigProductTypeList.push("IP7");
                    if (ip5_userGroupWellsFargo) gaigProductTypeList.push("IP5");
                    if (ia_userGroupWellsFargo) gaigProductTypeList.push("INDEX_ACHIEVER");
                    if (iaadvisory_userGroupWellsFargo) gaigProductTypeList.push("INDEX_ACHIEVER_ADVISORY");
                } else if (item.name === "Mass Mutual Financial Advisors") {
                    if (ip4_userGroupMmfa) gaigProductTypeList.push("IP4");
                    if (ip5mva_userGroupMmfa) gaigProductTypeList.push("IP5MVA");
                    if (ip7_userGroupMmfa) gaigProductTypeList.push("IP7");
                    if (ip5_userGroupMmfa) gaigProductTypeList.push("IP5");
                    if (ia_userGroupMmfa) gaigProductTypeList.push("INDEX_ACHIEVER");
                    if (iaadvisory_userGroupMmfa) gaigProductTypeList.push("INDEX_ACHIEVER_ADVISORY");
                }
                return {
                    ...item,
                    "gaigProductTypeList": gaigProductTypeList
                }
            });

            axios({
                method: 'post',
                url: Config.serverUrl + "/annuity-calculator/institute-product",
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then((response) => {
                dispatch({
                    type: actionTypes.ADMIN_PAGE_SET_SAVED,
                    value: true
                });
            }).catch((err) => {
                dispatch({
                    type: actionTypes.SET_ERROR_STATE,
                    errorMessage: "There was a problem when saving institution products to the database."
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/store/actionCreators.js